import { useOktaAuth } from '@okta/okta-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCurrentUserEmail } from '@/components/hooks/useCurrentUserEmail';
import { useFeatureFlags } from '../../constants/featureFlags';
import { PageRoutes } from '../../routes';
import {
    EVENT_LOG_NAMES,
    getLoggingContext,
    honeybadgerLogEvent,
} from '../../utils/logging';
import {
    ApplicantWrapper,
    HeaderContainer,
    Title,
    TitleWrapper,
    VerticalLine,
    ViewApplicantListLink,
} from './Header.StyledComponents';
import { HeaderDebugMenu } from './HeaderDebugMenu';

export const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { authState } = useOktaAuth();
    const userEmail = useCurrentUserEmail();
    const { isManageTemplatesEnabled } = useFeatureFlags();

    const handleORPClick = () => {
        navigate(PageRoutes.HOME);
    };

    const handleViewApplicantClick = () => {
        const userId = authState?.idToken?.claims?.sub;

        honeybadgerLogEvent(EVENT_LOG_NAMES.ViewApplicantQueueClick, {
            level: 'INFO',
            customAttributes: {
                ...getLoggingContext(userEmail, userId),
                currentPage: window.location.pathname,
                timestamp: new Date().toISOString(),
            },
        });

        navigate(PageRoutes.APPLICANTS);
    };

    const handleRecentNMIClick = () => {
        navigate(PageRoutes.RECENT_NEEDS_MORE_INFO);
    };

    const handleManageTemplatesClick = () => {
        navigate(PageRoutes.MANAGE_TEMPLATES);
    };

    const isRecentNMIActive = location.pathname === PageRoutes.RECENT_NEEDS_MORE_INFO;
    const isApplicantQueueActive = location.pathname === PageRoutes.APPLICANTS;
    const isManageTemplatesActive = location.pathname === PageRoutes.MANAGE_TEMPLATES;

    return (
        <HeaderContainer data-testid="header-container">
            <TitleWrapper>
                <Title onClick={handleORPClick}>Originations Review Portal</Title>
                <HeaderDebugMenu />
            </TitleWrapper>
            <ApplicantWrapper>
                {isManageTemplatesEnabled ? (
                    <>
                        <ViewApplicantListLink
                            data-testid="manage-templates-link"
                            onClick={handleManageTemplatesClick}
                            className={isManageTemplatesActive ? 'active' : ''}
                        >
                            Manage Templates
                        </ViewApplicantListLink>
                        <VerticalLine />
                    </>
                ) : null}
                <ViewApplicantListLink
                    data-testid="recent-nmi-link"
                    data-disabled
                    onClick={handleRecentNMIClick}
                    className={isRecentNMIActive ? 'active' : ''}
                >
                    Recent NMI Sent
                </ViewApplicantListLink>
                <VerticalLine />
                <ViewApplicantListLink
                    data-testid="view-applicant-queue"
                    data-disabled
                    onClick={handleViewApplicantClick}
                    className={isApplicantQueueActive ? 'active' : ''}
                >
                    Applicant Queue
                </ViewApplicantListLink>
            </ApplicantWrapper>
        </HeaderContainer>
    );
};
